export type OnboardingStep = {
  index: number
  title: string,
  description: string,
  image?: string
  video?: string
  buttonLabel?: string
}

export enum UserGuide {
  Quests = 'quests',
  Improve = 'improve',
  LoyaltyLeaderboard = 'loyalty_leaderboard',
}